/**
 * 캐시 입출금 팝업 (/adm/member/cash/inout?dirverNum=…) — 관리자가 회원 캐시를 넣고 뺀다
 * ($j.Pages.Admin.CashInout / body data-page-name="CashInout")
 *
 * 사유를 고르면 입출금·방법·금액·메모를 채워 주고(CI_PRESET), 출금 후 잔액이 음수면 실행을 막는다.
 * 보유 캐시·회원 이름 등 서버 값은 #page-data 로 받는다.
 */
export default class CashInout {
    initialize() { initialize(); }
}

// 서버 값 (컨트롤러 $pageData → #page-data) — initialize 가 채운다
var ciBaseCash  = 0;
var ciDirverNum = 0;
var ciDom       = '';
var ciMemName   = '';
var ciNowYear   = '';
var ciNowMonth  = '';
var ciSubmitting = false;

// 사유별 자동완성 규칙. 채워 넣기만 할 뿐 담당자가 모두 고쳐 쓸 수 있다.
// fee:true 면 회비 년/월 선택줄을 쓰는 사유(메모는 exmemos 로 들어간다)
var CI_PRESET = {
    '프로그램사용료'          : { inorout:'출금', way:'기타', amount:44000, fee:true,  memo:'{name}_회비 출금' },
    '프로그램사용료 (카드결제)' : { inorout:'출금', way:'기타', amount:0,     fee:true,  memo:'{name}_회비 장기선결제' },
    '추가등록비'              : { inorout:'출금', way:'기타', amount:'',    fee:false, memo:'{name}_추가등록 ( * 톤) - 톤수입력필수' }
};
// 자동완성 사유가 아닌 것을 고르면 앞서 채워진 값을 이 기본값으로 되돌린다.
var CI_PRESET_NONE = { inorout:'입금', way:'', amount:'', fee:false, memo:'' };

function initialize(){
    const d = JSON.parse(document.getElementById('page-data').textContent);
    ciBaseCash  = d.baseCash;
    ciDirverNum = d.driverNum;
    ciDom       = d.dom;
    ciMemName   = d.memName;
    ciNowYear   = d.nowYear;
    ciNowMonth  = d.nowMonth;

    // 하단 버튼 — data-ci="close|history|submit"
    $(document).on('click', '[data-ci]', function(){
        const a = this.dataset.ci;
        if (a === 'close') self.close();
        else if (a === 'history') ciShowHistory();
        else if (a === 'submit') ciSubmit();
    });

    $('#ciAmount').on('keyup input', function(e){
        $j.Common.Form.formatNumberInput(e.target);
        ciCalcAmount();
    });
    $('#ciInorout').on('change', ciCalcAmount);
    $('#ciReason').on('change', function(){
        ciToggleFee();
        ciApplyPreset();
    });
    ciToggleFee();
}

// 회비 년/월 선택줄을 쓰는 사유인지 (프로그램사용료 계열)
function ciIsFeeReason(reason){
    return !!(CI_PRESET[reason] && CI_PRESET[reason].fee);
}

function ciApplyPreset(){
    var preset = CI_PRESET[$('#ciReason').val()] || CI_PRESET_NONE;

    $('#ciInorout').val(preset.inorout);
    $('[name=move_way]').val(preset.way);
    $('#ciAmount').val(preset.amount === '' ? '' : $j.Common.Util.formatNumber(preset.amount));

    if (preset.fee) {
        $('#ciFeeYear').val(ciNowYear);
        $('#ciFeeMonth').val(ciNowMonth);
    }
    // 메모는 쓰는 칸만 채우고 나머지는 비운다 (사유를 옮겨다녀도 잔상이 남지 않게)
    var memo = preset.memo.replace('{name}', ciMemName);
    $('#ciMemos').val(preset.fee ? '' : memo);
    $('#ciExMemos').val(preset.fee ? memo : '');

    ciCalcAmount();
}

function ciCalcAmount(){
    var inType = $('#ciInorout').val();
    var raw = String($('#ciAmount').val() || '').replace(/,/g, '');
    var s = parseInt(raw) || 0;
    var base = parseInt(ciBaseCash) || 0;
    var after = (inType === '출금') ? base - s : base + s;

    $('#ciCashAfter').val(after);
    $('#ciAfterAmount').text($j.Common.Util.formatNumber(after));

    var $notice = $('#ciNotice');
    if (inType === '출금' && after < 0) {
        $notice.text('출금 금액이 전체 금액보다 큽니다.');
        $('#ciSubmitBtn').prop('disabled', true);
    } else {
        $notice.text('');
        $('#ciSubmitBtn').prop('disabled', false);
    }
}

function ciToggleFee(){
    var feePopup = ciIsFeeReason($('#ciReason').val());
    $('#ciFeeRow').toggleClass('show', feePopup);
    // 레거시 호환: 회비/사용료 모드에서는 memos 는 "yyyy년mm월" 라벨 전송용으로 숨기고
    // 사용자 메모는 exmemos textarea 에 입력받는다.
    if (feePopup) {
        $('#ciMemos').hide();
        $('#ciExMemos').show();
    } else {
        $('#ciMemos').show();
        $('#ciExMemos').hide();
    }
}

function ciSubmit(){
    if (ciSubmitting) return;

    var inType = $('#ciInorout').val();
    var amount = String($('#ciAmount').val() || '').replace(/[\s,]/g, '');
    var amountNum = +amount;

    if (!inType) { alert('입금 또는 출금을 선택해 주세요.'); return; }
    // 빈값·음수·숫자아님은 차단. 0원은 허용하되 한번 더 확인.
    if (amount === '' || isNaN(amountNum) || amountNum < 0){ alert('금액을 입력해 주세요.'); $('#ciAmount').focus(); return; }
    if (amountNum === 0 && !confirm('금액이 0원입니다. 0원으로 처리하시겠습니까?')){ $('#ciAmount').focus(); return; }

    if (ciIsFeeReason($('#ciReason').val())) {
        var yy = $('#ciFeeYear').val();
        var mm = $('#ciFeeMonth').val();
        if (!yy || !mm) { alert('회비 년, 월을 선택해 주세요.'); return; }
        $('#ciMemos').val(yy + '년' + mm + '월');
    }

    $('#ciAmount').val(amount);
    ciCalcAmount();

    ciSubmitting = true;
    $('#ciSubmitBtn').prop('disabled', true);

    $.ajax({
        type: 'POST',
        url:  '/adm/ajax/member/cash/transaction',
        data: $('#ciForm').serialize(),
        success: function(data){
            if (!data.result) {
                $j.Common.Util.swalert(data.message || '처리에 실패했습니다.');
                ciSubmitting = false;
                $('#ciSubmitBtn').prop('disabled', false);
                return;
            }
            alert('적용되었습니다.');
            if (window.opener && !window.opener.closed) window.opener.location.reload();
            self.close();
        },
        error: function(){
            alert('네트워크 오류가 발생했습니다.');
            ciSubmitting = false;
            $('#ciSubmitBtn').prop('disabled', false);
        }
    });
}

function ciShowHistory(){
    if (window.$j && $j.F && $j.F.Admin && $j.F.Admin.Util) {
        $j.F.Admin.Util.userCash(ciDirverNum);
    } else {
        var url = '/_cash_inout_detail.php?dom=' + encodeURIComponent(ciDom) + '&dnum=' + ciDirverNum;
        var w = window.open(url, 'cachDetailEach', 'toolbar=no,status=no,WIDTH=600,HEIGHT=900,scrollbars=yes,resizable=yes');
        w.focus();
    }
}
